import { Action } from 'redux';

export enum ApplicationDataActionTypes {
    APPLICATION_LOAD_SUCCESS = 'APPLICATION_LOAD_SUCCESS',
    APPLICATION_LOAD_FAILURE = 'APPLICATION_LOAD_FAILURE'
}

export interface ApplicationDataSuccess extends Action {
    type: ApplicationDataActionTypes.APPLICATION_LOAD_SUCCESS;
    data: string;
}

export const applicationDataSuccess = (data: string) : ApplicationDataSuccess => ({
    type: ApplicationDataActionTypes.APPLICATION_LOAD_SUCCESS,
    data
});

export interface ApplicationDataFailure extends Action {
    type: ApplicationDataActionTypes.APPLICATION_LOAD_FAILURE;
    data?: string;
}

export const applicationDataFailure = (data: string): ApplicationDataFailure => ({
    type: ApplicationDataActionTypes.APPLICATION_LOAD_FAILURE,
    data
});

export type ApplicationDataActions = ApplicationDataSuccess | ApplicationDataFailure;